export class SolicitudAhorro {

  idSolicitudAhorros: string;
  idSolicitud: string;
  idPlantilla: string;
  idPlantillaVersion: string;
  fechaTransaccion: Date;
  direccionIp: string;
  tipoDispositivo: string;
  latitud: string;
  longitud: string;
  numeroCuenta: string;
  IndicadorPendiente: boolean;
  indicadorHabilitado: boolean;
  auditoriaFecha: Date;
  auditoriaUsuario: string;
  constructor() {
    this.indicadorHabilitado = true;
  }
}
